import { OverviewView } from '@/features/overview';
import { useViewer } from '@/features/session';

export function OverviewPage() {
  const { workspace } = useViewer();
  return workspace ? <OverviewView workspace={workspace} /> : null;
}
